import { notificationTypeConstants } from "../constants";
import { alertActions } from 'actions';
import { global } from 'config';
import { notificationTypeService } from 'services';

import { gisRoutes } from '../routes/routes';
import { history } from 'helpers';
import phrasebookLoad from "../i18n";
const phrasebook = phrasebookLoad()

export const notificationTypeActions = {
  get,
  getAll,
  add,
  update
}

function getAll(limit = global.LIMIT, page = global.PAGE, filters = undefined) {
  return dispatch => {
    dispatch(request());

    notificationTypeService.getAll(limit, page, filters)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: notificationTypeConstants.GET_NOTIFICATION_TYPES_REQUEST } }
  function success(data) { return { type: notificationTypeConstants.GET_NOTIFICATION_TYPES_SUCCESS, data } }
  function failure(error) { return { type: notificationTypeConstants.GET_NOTIFICATION_TYPES_FAILURE, error } }
}

function get(notification_type_id) {
  return dispatch => {
    dispatch(request());

    notificationTypeService.get(notification_type_id)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: notificationTypeConstants.GET_NOTIFICATION_TYPE_REQUEST } }
  function success(data) { return { type: notificationTypeConstants.GET_NOTIFICATION_TYPE_SUCCESS, data } }
  function failure(error) { return { type: notificationTypeConstants.GET_NOTIFICATION_TYPE_FAILURE, error } }
}



function add(newValues) {
  return dispatch => {
    dispatch(request(newValues));

    notificationTypeService.add(newValues)
      .then(
        data => {
          dispatch(success());
          dispatch(alertActions.success(data.message));
          history.push(gisRoutes.support.tickets.add);
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: notificationTypeConstants.ADD_NOTIFICATION_TYPE_REQUEST } }
  function success() { return { type: notificationTypeConstants.ADD_NOTIFICATION_TYPE_SUCCESS } }
  function failure(error) { return { type: notificationTypeConstants.ADD_NOTIFICATION_TYPE_FAILURE, error } }
}

function update(notification_type_id, updatedValues) {
  return dispatch => {
    dispatch(request(updatedValues));

    notificationTypeService.update(notification_type_id, updatedValues)
      .then(
        data => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));

        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: notificationTypeConstants.UPDATE_NOTIFICATION_TYPE_REQUEST } }
  function success() { return { type: notificationTypeConstants.UPDATE_NOTIFICATION_TYPE_SUCCESS } }
  function failure(error) { return { type: notificationTypeConstants.UPDATE_NOTIFICATION_TYPE_FAILURE, error } }
}
